export default __webpack_public_path__ + "static/media/Q14_2_resized.9219d42c.jpg";